import { render, staticRenderFns } from "./Step2_Participants.vue?vue&type=template&id=aa2f8768"
import script from "./Step2_Participants.vue?vue&type=script&lang=js"
export * from "./Step2_Participants.vue?vue&type=script&lang=js"
import style0 from "./Step2_Participants.vue?vue&type=style&index=0&id=aa2f8768&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports